import React from 'react';
import styled from 'styled-components';
import ChildItemBackgroundPose from './ChildItemBackgroundPose';
import CropDisplay from './CropDisplay';

const ProductName = styled.p`
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 6px;
`;

const Header = styled.h6`
  font-size: 14px;
  font-style: italic;
  font-weight: normal;
  margin-bottom: 16px;
`;

const ChildWrapper = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ProductOptionsWrapper = styled.div`
  margin-top: 8px;
  margin-left: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
`;

const OptionLabel = styled.span`
  font-weight: 600;
  color: #333;
`;

const ProductWithChildElements = ({
  cartItem,
  shouldDisplayBackgroundPrice,
  singleChargeForBackgroundUpgrades,
}) => {
  let hasDisplayedBackgroundPrice = false; // Track if we've already displayed a background price

  return (
    <>
      <Header>components</Header>

      {cartItem.children.map((item, index) => {
        // Determine if we should display the background price for this child item
        let shouldShowPrice = shouldDisplayBackgroundPrice;

        if (
          shouldDisplayBackgroundPrice &&
          singleChargeForBackgroundUpgrades &&
          !hasDisplayedBackgroundPrice &&
          item.backgrounds.some((background) => background.price > 0)
        ) {
          shouldShowPrice = true;
          hasDisplayedBackgroundPrice = true; // Set flag to true after the first price is displayed
        } else if (singleChargeForBackgroundUpgrades) {
          shouldShowPrice = false; // Don't show the price for subsequent items
        }

        return (
          <ChildWrapper
            key={item.id}
            onContextMenu={(event) => event.preventDefault()}
          >
            <ProductName>{item.productName}</ProductName>
            <ChildItemBackgroundPose
              shouldDisplayBackgroundPrice={shouldShowPrice}
              item={item}
              isLastItem={
                item.selectedCropOptions?.length > 0
                  ? false
                  : index === cartItem.children.length - 1
              }
              singleChargeForBackgroundUpgrades={
                singleChargeForBackgroundUpgrades
              }
            />
            {item.selectedProductOptions &&
              item.selectedProductOptions.length > 0 && (
                <ProductOptionsWrapper>
                  {item.selectedProductOptions.map((option, optIndex) => (
                    <div key={`child-option-${optIndex}`}>
                      <OptionLabel>
                        {option.optionSetDisplayName ||
                          option.optionSetName ||
                          'Option'}
                        :
                      </OptionLabel>{' '}
                      {option.optionName}
                      {option.optionPrice > 0 &&
                        ` (+$${(option.optionPrice / 100).toFixed(2)})`}
                    </div>
                  ))}
                </ProductOptionsWrapper>
              )}
            {item.selectedCropOptions &&
              item.selectedCropOptions.length > 0 &&
              item.selectedCropOptions.map((selection, cropIndex) => (
                <CropDisplay key={`child-crop-${cropIndex}`}>
                  <b>
                    Crop Style
                    {item.selectedCropOptions.length > 1
                      ? ` (Pose ${cropIndex + 1})`
                      : ''}
                    :
                  </b>{' '}
                  {selection.displayName}
                </CropDisplay>
              ))}
          </ChildWrapper>
        );
      })}
    </>
  );
};

export default ProductWithChildElements;
